/* eslint-disable no-new */
import {Accordion, analytics, Modal, SocialShareButton, Subscribe, cookieHelper, isMobile, slideToggle, slideDown} from '@shopify/marketing-assets';
import Waypoint from 'waypoints';

import {Tweetable} from '../components/tweetable';
import {StickyBanner} from '../modules/sticky-banner';
import '../modules/sticky-banner-modal';
import '../modules/blog/clickable-image';
import '../components/storename-autogen-signup-smart-field';

function looseProcedures() {
  new Accordion(document.getElementById('SidebarAccordion'), {
    mobileOnly: accordionBooleanAllDevices(),
    itemSelector: '.accordion-item--mobile',
    openFirst: false,
  });

  document.querySelectorAll('.js-social-share').forEach((el) => new SocialShareButton(el));
}

function accordionBooleanAllDevices() {
  const accordionOverrideDefaultBehaviour = document.getElementById("CollapsedAccordionBlogSidebar");
  const accordionItems = document.querySelectorAll(".accordion-item--mobile");

  // remove empty id attributes
  accordionItems.forEach((accordionItem) => {
    if (accordionItem.attributes.id.value === "" && accordionOverrideDefaultBehaviour === null) {
      accordionItem.removeAttribute("id");
    }
  });

  return !accordionOverrideDefaultBehaviour;
}

function truncatedText() {
  // Truncated text snippets can be manually added to any blog post but the JS
  // for the functionality lives here.
  const truncatableTextElem = document.querySelector('.truncated-text');
  const truncatableToggleElem = document.querySelector('.truncated-text__toggle');
  if (truncatableTextElem && truncatableToggleElem) {
    truncatableToggleElem.querySelector('button').addEventListener('click', () => {
      truncatableTextElem.classList.add('js-is-active');
    });
  }
}

function initGuideModals() {
  // Initialise any guide modals
  const modalOptions = {
    afterModalRender: ($modal) => {
      new Subscribe($modal);
      document.querySelector('.guide-cta__subscribe--success-button').addEventListener('click', () => {
        window.ShopifyMarketing.signup.SignupModal.open();
      });
    },
  };

  // Populate any empty signup_page fields (Guide CTAs and Subscribe)
  document.querySelectorAll('input[name="signup_page"]').forEach((el) => {
    if (el.value.length === 0) {
      el.value = window.location.href;
    }
  });

  document.querySelectorAll('.js-guide-cta').forEach((el) => {
    const trigger = el.querySelectorAll('.guide-cta__trigger');
    const modalContent = el.querySelector('.guide-cta__modal').innerHTML;

    new Modal(
      trigger,
      () => modalContent,
      modalOptions,
    );
  });
}

function initTweetableElements() {
  // Initialise any tweetable elements
  document.querySelectorAll('[data-tweet]').forEach((el) => new Tweetable(el));
}

function stickyScrollTracker() {
  // Track scroll past waypoint if there is no sticky banner
  const stickyBannerContainer = document.querySelector('.sticky-banner-container');
  if (stickyBannerContainer === null) {
    const subNavList = document.getElementById('ShopifySubNavList');
    const blogHeader = document.querySelector('[data-blog-sticky-banner-waypoint]');
    const element = subNavList || blogHeader;

    if (element) {
      const waypoint = new Waypoint({
        element,
        offset: -element.clientHeight,
        handler: (dir) => {
          if (dir !== 'down') {
            return;
          }
          analytics.track({
            eventCategory: 'sticky-banner-waypoint',
            eventAction: 'scroll-past',
            eventLabel: 'sticky-banner-no-show',
            nonInteraction: true,
          });
          waypoint.disable();
        },
      });
    }
  } else {
    const stickySidePrompt = document.querySelector('.sticky-side-prompt__container');
    if (stickySidePrompt) {
      // display original sticky banner on smaller screen sizes/hide on $desktop-up
      stickyBannerContainer.classList.add('sticky-side-prompt-tablet');

      // if scroll too fast without onload, Waypoint doesn't get initialized correctly & side prompt isn't sticky on scroll
      window.onload = () => {
        new Waypoint({
          element: stickySidePrompt,
          offset: 100,
          handler: (dir) => {
            const parentwidth = document.querySelector('#SidebarAccordion');
            stickySidePrompt.setAttribute('style', `width: ${parentwidth.clientWidth}px`);

            if (dir === 'down') {
              stickySidePrompt.classList.add('fixed-sticky-side-prompt');
            } else {
              stickySidePrompt.classList.remove('fixed-sticky-side-prompt');
            }
          },
        });

        const cookie = cookieHelper;
        const stickySidePromptCookies = 'sticky-side-prompt';

        const getSidePromptCookies = () => {
          return cookie.get(stickySidePromptCookies);
        };

        if (!getSidePromptCookies()) {
          stickySidePrompt.classList.remove('sticky-side-prompt-closed');
        }

        const setUserViewedSidePrompt = () => {
          cookie.set(stickySidePromptCookies, true);
        };

        const handleStickySidePromptClose = (evt) => {
          if (!(evt.keyCode === 13 || evt === 'click')) {
            return;
          }

          stickySidePrompt.classList.add('sticky-side-prompt-closed');
          stickySidePrompt.setAttribute('aria-hidden', 'true');
          setUserViewedSidePrompt();
        };


        const stickySidePromptCloseButton = document.querySelector('.sticky-side-prompt-close');
        const events = ['click', 'keypress'];
        events.forEach((evt) => {
          stickySidePromptCloseButton.addEventListener(evt, () => handleStickySidePromptClose(evt));
        });
      };
    }

    if (document.querySelector('.sticky-modal')) {
      setTimeout(() => new ShopifyMarketing.StickyBannerModal(stickyBannerContainer).open(), 6000);
    }

    new StickyBanner(stickyBannerContainer);
  }
}

function interstitialCtaBlog() {
  // interstitial cta rollout
  const emptyCtaDiv = document.querySelector('#article-cta');
  const interstitCtaDiv = document.querySelector('.interstitial-cta-blog-cta');

  if (emptyCtaDiv && interstitCtaDiv) {
    interstitCtaDiv.style.display = "flex";
    emptyCtaDiv.appendChild(interstitCtaDiv);
  }
}

function mobileInterstialCtaBlog() {
  // mobile interstitial cta rollout on all articles
  const ctaDiv = document.querySelector('#embedded-cta');
  const allParagraphs = document.querySelectorAll('.article__content.long-form-content > p');
  const interstitialCtaDiv = document.querySelector('.interstitial-cta-blog-cta');

  if (ctaDiv && allParagraphs[3]) {
    interstitialCtaDiv.style.display = 'flex';
    allParagraphs[3].after(ctaDiv);
  }
}

function interlinkingBlog() {
  // interlinking rollout on all articles
  const faqDiv = document.querySelectorAll('[itemtype*=FAQ]');
  const readMoreInterlinkingDiv = document.querySelector('.read-more-interlinking');
  const longFormContent = document.querySelector('.article__content.long-form-content');

  if (faqDiv[0] && readMoreInterlinkingDiv && faqDiv[0].parentElement) {
    readMoreInterlinkingDiv.style.display = 'table-cell';
    readMoreInterlinkingDiv.classList.add('interlinking-margin');
    faqDiv[0].before(readMoreInterlinkingDiv);
  } else if (faqDiv[0] && readMoreInterlinkingDiv && faqDiv[0].parentElement == null) {
    readMoreInterlinkingDiv.style.display = 'inline-block';
    readMoreInterlinkingDiv.classList.add('interlinking-margin');
    faqDiv[0].before(readMoreInterlinkingDiv);
  } else if (longFormContent && readMoreInterlinkingDiv) {
    readMoreInterlinkingDiv.style.display = 'inline-block';
    readMoreInterlinkingDiv.style.padding = '0px 18px';
    longFormContent.appendChild(readMoreInterlinkingDiv);
  }
}

function handleSlideupModal() {
  // slideup modal rollout
  const Cookie = cookieHelper;
  const modalCookies = 'slideup-modal';

  const slideupModalEl = document.querySelector('.slideup-modal');
  const stickyBannerContainerEl = document.querySelector('.sticky-banner-container');
  const desktopUser = (window.innerWidth >= 1080);
  let timeoutId;

  function setClientViewedSlideup() {
    Cookie.set(modalCookies, true);
  }

  if (Cookie.get(modalCookies) || !slideupModalEl || !desktopUser) {
    return;
  }

  if (stickyBannerContainerEl) {
    stickyBannerContainerEl.style.display = 'none';
  }

  setTimer();

  function openSlideupModal() {
    slideupModalEl.classList.remove('slideup-modal-closed');
  }

  function closeSlideupModal(evt) {
    if (!(evt.keyCode === 13 || evt === 'click')) {
      return;
    }

    slideupModalEl.classList.add('slideup-modal-closed');
    setClientViewedSlideup();
  }

  function handleCloseButton() {
    const modalCloseButtonEl = document.querySelector('.close-slideup-modal');
    const events = ['click', 'keypress'];
    events.forEach((evt) => {
      modalCloseButtonEl.addEventListener(evt, () => closeSlideupModal(evt));
    });
  }

  // Promisifying setTimeout() method
  function wait(ms) {
    return new Promise((resolve) => {
      timeoutId = setTimeout(resolve, ms);
    });
  }

  async function setTimer() {
    await wait(3000);
    clearTimeout(timeoutId);
    openSlideupModal();
    handleCloseButton();
  }
}

function jpModalBg() {
  // jp modal bg colour rollout
  if (document.documentElement.lang !== 'ja') { return; }
  const modalContainer = document.getElementById('ModalContainer');
  modalContainer.classList.add('modal-container--green');
}

function insertTextLinkCta() {
  // Adds text-based CTAs to blog articles
  const textCta = document.querySelector('#text-cta');
  const h2Elements = document.querySelectorAll('h2');
  const pElement = document.querySelectorAll('.article__content.long-form-content > p')[2];
  if (!(textCta && pElement && h2Elements)) { return; }

  pElement.after(textCta);
  textCta.classList.remove('text-cta__hidden');
}

function insertNewCta() {
  const textCta = document.querySelector('#new-article-cta');
  const h2Elements = document.querySelectorAll('h2');
  const targetP = document.querySelectorAll('.article__content.long-form-content > p')[3];
  if (!(textCta && targetP && h2Elements)) { return; }

  targetP.after(textCta);
  textCta.classList.remove('new-article-cta__hidden');
}

function layOutPaginationEl() {
  if (!isMobile) { return; }

  const nextPage = document.getElementById('ModifiedPaginationNextPage');

  if (!nextPage) { return; }

  const paginationParentEl = document.getElementById('ModifiedPaginationCoreBlog');
  const primaryPages = document.getElementById('ModifiedPaginationPrimaryPages');
  paginationParentEl.insertBefore(nextPage, primaryPages);
}

// Allows the secondary nav to expand on blog
function setupSecondaryNav() {
  const remixNavPresent = document.getElementById('partials-root');
  if (window.location.href.includes('shopify.engineering')) {
    // do nothing
  } else {
    const mobileSelectEl = document.getElementById('ShopifyNavMobileSelect');
    const itemsWrapperEl = document.getElementById('ShopifySubNavList');
    itemsWrapperEl?.parentElement.classList.add('marketing-nav--skin-light');
    const popoverTriggerEl = document.querySelector('.popover__trigger');
    const popoverWrapperEl = document.querySelector('.popover-wrapper');

    const toggleSecondaryNavAccordion = () => {
      if (!remixNavPresent) { return; }

      if (itemsWrapperEl.getAttribute('style')?.includes('overflow: visible')) {
        itemsWrapperEl.style.overflow = 'hidden';
        popoverWrapperEl.classList.remove('is-active');
      }

      const newState = !itemsWrapperEl.classList.contains('js-is-active');

      mobileSelectEl.setAttribute('aria-expanded', newState);
      itemsWrapperEl.classList.toggle('js-is-active');

      slideToggle(itemsWrapperEl);
    };

    const toggleSecondaryNavDropdownAccordion = () => {
      if (!remixNavPresent) { return; }

      const newState = !popoverWrapperEl.classList.contains('is-active');

      popoverTriggerEl.setAttribute('aria-expanded', newState);
      popoverWrapperEl.classList.toggle('is-active');

      slideDown(popoverWrapperEl, 400);

      if (popoverWrapperEl.getAttribute('style')?.includes('overflow: hidden')) {
        itemsWrapperEl.style.overflow = 'visible';
        popoverWrapperEl.style.overflow = 'visible';
      } else if (popoverWrapperEl.getAttribute('style')?.includes('overflow: visible')) {
        itemsWrapperEl.style.overflow = 'hidden';
        popoverWrapperEl.style.overflow = 'hidden';
      }
    };

    mobileSelectEl?.addEventListener('click', () => toggleSecondaryNavAccordion());
    popoverTriggerEl?.addEventListener('click', () => toggleSecondaryNavDropdownAccordion());
  }
}

function init() {
  looseProcedures();
  truncatedText();
  initGuideModals();
  initTweetableElements();
  stickyScrollTracker();
  interstitialCtaBlog();
  mobileInterstialCtaBlog();
  interlinkingBlog();
  handleSlideupModal();
  jpModalBg();
  insertTextLinkCta();
  layOutPaginationEl();
  insertNewCta();
  setupSecondaryNav();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
